import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { taskUrlForUsecase } from '@/features/tasks/utils/navigation';

/**
 * Dispatches `task:add-data` / `task:generate-with-ai` / `task:retrieval-agent`
 * for `TaskPage` listeners.
 * When the user is not on `/task/...`, navigates to the task landing first so
 * the listener is mounted before the event fires.
 */
export function useTaskDataWindowEvents() {
    const navigate = useNavigate();
    const location = useLocation();
    const isTaskLanding = location.pathname.startsWith('/task/');

    const dispatchTaskDataEvent = useCallback(
        (eventName, detail, usecaseForUrl) => {
            if (isTaskLanding) {
                window.dispatchEvent(new CustomEvent(eventName, { detail }));
                return;
            }
            const url = taskUrlForUsecase(usecaseForUrl, { objective: detail?.usecaseId });
            if (!url) return;
            navigate(url);
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent(eventName, { detail }));
            }, 50);
        },
        [isTaskLanding, navigate]
    );

    return { dispatchTaskDataEvent, isTaskLanding };
}
